import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import Select from 'react-select'
import { Table, Checkbox } from 'rsuite'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import { ReactComponent as SvgDownload } from '../../../../assets/svg/download.svg'
import { removeMaster, addSupplierHistory, getChildSuppliers, getChildSuppliersByUserCount, getChildSuppliersWithMasterIds } from '../../../../redux/actions/vendor'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { getAbbreviatedState } from '../../../../services/helper'
import moment from 'moment'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, isLoading = false, ...props }) => {
  let bgColorClass = rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : 'bg-yellow'
  let stateCode = ''
  if (dataKey === 'state') {
    if (rowData?.abbreviatedState === null) {
      stateCode = getAbbreviatedState(rowData?.abbreviatedState, rowData?.state)
    } else {
      stateCode = rowData?.abbreviatedState
    }
  }
  if (dataKey === 'contactDate') {
    const importedDate = rowData?.['contactDate'] ? moment(rowData?.['contactDate']).format('MM/DD/YYYY') : '';
    rowData[dataKey] = importedDate
  }
  return (
    <Cell {...props} className="table-link">
      {dataKey === 'state' ?
        stateCode
        :
        dataKey === 'supplierQARole' ?
          <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
            {rowData[dataKey]}
          </h5>
          :
          dataKey === 'contactDate' ?
            rowData[dataKey]
            :
            <button className='text-primary' type="button" disabled={dataKey === 'suppliername' && isLoading} onClick={() => onClick(rowData.id)}>
              {rowData[dataKey]}
            </button>
      }
    </Cell>
  )
}

const LookupRecordComponent = ({
  onShowExportModal, onShowCreateMasterModal, onAssignMaster,
  tableData, finalUploadedData, showOnlyUploadedSuppliers = true,
  onCheckUploadedSuppliers, selectedChildrens, onSearchSimiliarVendors, masterSuppliers, checkedRelatedSupplierRow, totalRecords, searchList, onAddChildSupplier, isChildrenFiltered = false, filteredChildrenMasterIds = [], isAssigningToMaster = false
}) => {

  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    app: { childSupplierColumns },
    vendor: { isLoadingChildSupplier, isRemovingFromMaster, isAssigningMaster, suppliersSearchList, suppliersSearchResults },
    auth: { user }
  } = store
  const [checkedKeys, setCheckedKeys] = useState([])
  const [checkedSuppliers, setCheckedSuppliers] = useState([])
  const [lookupOption, setLookupOption] = useState({ label: 'Assign To Master', value: 'assign-master' })
  const [showHasMaster, setShowHasMaster] = useState(false)
  const [showNoMaster, setShowNoMaster] = useState(false)

  const [sortColumn, setSortColumn] = useState('id')
  const [sortType, setSortType] = useState('asc')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [paginatedData, setPaginatedData] = useState([])
  const [totalTableRecords, setTableTotalRecords] = useState(0)
  const [childSuppliers, setChildSuppliers] = useState([])

  useEffect(() => {
    if (!isAssigningToMaster) {
      setPage(1)
      setShowNoMaster(false)
      setShowHasMaster(false)
    }
    setTableTotalRecords(totalRecords)
    setPaginatedData(tableData)
    setChildSuppliers(tableData)
    setCheckedSuppliers([])
    setCheckedKeys([])
  }, [totalRecords])//[searchList, searchTarget]

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    dispatch(getChildSuppliers({
      limit: dataKey,
      offset: 0,
      searchList,
      noMaster: showNoMaster,
      hasMaster: showHasMaster
    })).then(async (res) => {
      setPaginatedData(res?.childSuppliers)
      setChildSuppliers(res?.childSuppliers)
      setCheckedSuppliers([])
      setCheckedKeys([])
    })
  }

  const handleChangePage = (event) => {
    setPage(event)
  }

  const lookupOptions = [
    {
      label: 'Search Simliar Child Suppliers',
      value: 'search',
    },
    {
      label: 'Assign To Master',
      value: 'assign-master',
    },
    {
      label: 'Create Master Supplier',
      value: 'create-master',
    },
    {
      label: 'Remove from Master Supplier',
      value: 'remove-master',
    }
  ]

  const handleClickRelatedSuppplierData = (value) => {
    let selectedSupplier = [];
    selectedSupplier = [...selectedSupplier, showOnlyUploadedSuppliers ? finalUploadedData.find(row => row.id === value) : childSuppliers.find(row => row.id === value)]
    checkedRelatedSupplierRow(selectedSupplier)
  }

  const headerElement = childSupplierColumns.map((h, index) => {
    const sortableColumns = ['suppliername', 'address1', 'address2', 'city', 'state', 'zip', 'country']
    const isSortable = sortableColumns?.includes(h.name)
    if (index === 0) {
      return (
        <Column
          resizable
          sortable={isSortable}
          key={h.name}
        >
          <HeaderCell>{h.label}</HeaderCell>
          <LinkCell dataKey={h.name} isLoading={isLoadingChildSupplier} onClick={handleClickRelatedSuppplierData} />
        </Column>
      )
    }
    return (
      <Column
        resizable
        sortable={isSortable}
        key={h.name}
      >
        <HeaderCell>{h.label}</HeaderCell>
        {(h.name === 'state' || h.name === 'contactDate') ?
          <LinkCell dataKey={h.name} />
          :
          <Cell dataKey={h.name} />
        }
      </Column>
    )
  })

  let checked = false
  let indeterminate = false
  if (checkedKeys && childSuppliers && checkedKeys.length === childSuppliers.length) {
    checked = true;
  } else if (checkedKeys && checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys && childSuppliers && checkedKeys.length > 0 && checkedKeys.length < childSuppliers.length) {
    indeterminate = true;
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, disabled, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Checkbox
        value={rowData[dataKey]}
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
        disabled={disabled}
      />
    </Cell>
  )

  useEffect(() => {
    if (!(childSuppliers && childSuppliers.length > 0 && checkedKeys && checkedKeys.length > 0)) {
      return
    }
    setCheckedSuppliers(showOnlyUploadedSuppliers ? [...finalUploadedData.filter(row => checkedKeys.includes(row.id))] : [...childSuppliers.filter(row => checkedKeys.includes(row.id))]);
  }, [childSuppliers, checkedKeys])

  useEffect(() => {
    if (!(tableData && tableData.length > 0)) {
      setTableTotalRecords(0)
      setPaginatedData([])
      setChildSuppliers([])
      return
    }
    setTableTotalRecords(totalRecords)
    setPaginatedData(tableData)
    setChildSuppliers(tableData)
    if (selectedChildrens.length === 0) {
      setLimit(10)
    }
  }, [tableData])

  const handleCheckAll = (value, checked) => {
    let keys = checked ? childSuppliers.map(item => item.id) : []
    if (showOnlyUploadedSuppliers) {
      keys = checked ? finalUploadedData.map(item => item.id) : []
      if (checked) {
        setCheckedSuppliers(finalUploadedData)
      } else {
        setCheckedSuppliers([])
      }
    } else {
      if (checked) {
        setCheckedSuppliers(childSuppliers)
      } else {
        setCheckedSuppliers([])
      }
    }
    setCheckedKeys(keys)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value)
    setCheckedKeys(nextCheckedKeys)
    let tmpCheckedSuppliers = [...checkedSuppliers];
    if (showOnlyUploadedSuppliers) {
      if (checked) {
        tmpCheckedSuppliers = [...tmpCheckedSuppliers, finalUploadedData.find(row => row.id === value)]
      } else {
        tmpCheckedSuppliers = tmpCheckedSuppliers.filter(row => row.id !== value)
      }
    } else {
      if (checked) {
        tmpCheckedSuppliers = [...tmpCheckedSuppliers, childSuppliers.find(row => row.id === value)]
      } else {
        tmpCheckedSuppliers = tmpCheckedSuppliers.filter(row => row.id !== value)
      }
    }
    setCheckedSuppliers(tmpCheckedSuppliers)
  }
  const handleCheckUploadedSuppliers = (value, checked) => {
    onCheckUploadedSuppliers(checked)
  }
  const handleCheckNoMaster = (value, checked) => {
    setShowNoMaster(checked);
    setPage(1);
    setCheckedKeys([]);
    setCheckedSuppliers([]);
  }
  const handleCheckHasMaster = (value, checked) => {
    setShowHasMaster(checked);
    setPage(1);
    setCheckedKeys([]);
    setCheckedSuppliers([]);
  }
  const handleLookupOptionChange = (value) => {
    setLookupOption(value)
  }

  const isExistMaster = () => {
    const supplierName = checkedSuppliers[0].suppliername
    var result = 'false'
    masterSuppliers.map(element => {
      if (element.suppliername === supplierName) {
        result = 'true'
        return result
      }
    })
    return result
  }

  const onSubmit = () => {
    if (!checkedKeys || !checkedKeys.length) {
      toast.show({
        title: 'Warning',
        description: 'No suppliers are selected!',
      })
      return
    }

    const alreadyAssignedSuppliers = checkedSuppliers.filter(supplier => supplier.masterId)
    switch (lookupOption.value) {
      case 'search':
        onSearchSimiliarVendors(checkedKeys)
        break
      case 'assign-master':
        if (alreadyAssignedSuppliers && alreadyAssignedSuppliers.length > 0) {
          toast.show({
            title: 'Warning',
            description: 'The Child Suppliers you\'ve selected are already assigned to a Master Supplier. You must first use the "Remove From Master Supplier" option',
            duration: 6000,
          })
          return
        }
        onAssignMaster(checkedKeys, showHasMaster, showNoMaster, page)
        break

      case 'create-master':
        if (alreadyAssignedSuppliers && alreadyAssignedSuppliers.length > 0) {
          toast.show({
            title: 'Warning',
            description: 'The Child Suppliers you\'ve selected are already assigned to a Master Supplier. You must first use the "Remove From Master Supplier" option',
            duration: 6000,
          })
          return
        }
        if (isExistMaster() === 'true') {
          toast.show({
            title: 'Warning',
            description: 'A Supplier with the same name as the one you selected has already been created as a master supplier.',
            duration: 6000,
          })
          return
        }
        onShowCreateMasterModal(checkedKeys, checkedSuppliers)
        break

      case 'remove-master':
        const supplierWithoutMaster = checkedSuppliers.filter(supplier => supplier.masterId === null)
        if (supplierWithoutMaster && supplierWithoutMaster.length > 0) {
          toast.show({
            title: 'Warning',
            description: 'The Child Suppliers you\'ve selected are not assigned to Master Supplier. Please select only those Child Suppliers that are assigned to Master Supplier.',
            duration: 6000,
          })
          return
        }

        dispatch(removeMaster(checkedKeys)).then(async () => {
          var checkedKeysArray = []
          checkedKeys.map(value => {
            let SupllierData = checkedSuppliers.filter(supplier => {
              if (supplier.id === value) {
                return supplier
              }
            })

            let note = 'Child supplier removed from Master ' + '<a target="_blank" href="/suppliers/' + SupllierData?.[0]?.masterId + '"><b>' + SupllierData?.[0]?.masterSupplierName + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
            checkedKeysArray.push({ id: value, note: note })
          })
          await dispatch(
            addSupplierHistory({
              supplierId: checkedKeysArray,
              note: '',
              noteType: 'changelog'
            })
          )
          var tmpSearchList = searchList
          if (suppliersSearchList?.child && Object.keys(suppliersSearchList?.child)?.length > 0) {
            var tmpSearchList = suppliersSearchList?.child
          }
          dispatch(getChildSuppliers({
            limit: limit,
            offset: limit * (page - 1),
            searchList: tmpSearchList,
            noMaster: showNoMaster,
            hasMaster: showHasMaster,
            sortColumn,
            sortType
          })).then(async (res) => {
            setPaginatedData(res?.childSuppliers)
            setTableTotalRecords(res?.totalChilds || 0)
            setChildSuppliers(res?.childSuppliers)
            setCheckedSuppliers([])
            setCheckedKeys([])
          })
        })
        break
      default:
        break
    }
  }

  const onDownload = (data) => {
    const exportData = [childSupplierColumns.map(column => column.label)]
    exportData.push(...data.map(row => {
      return childSupplierColumns.map(column => row[column.name])
    }))
    onShowExportModal(exportData, 'child_supplier')
  }

  const handleSortTableData = (sortColumn, sortType) => {
    setSortColumn(sortColumn)
    setSortType(sortType)
    var tmpSearchList = searchList
    if (suppliersSearchList?.child && Object.keys(suppliersSearchList?.child)?.length > 0) {
      var tmpSearchList = suppliersSearchList?.child
    }
    dispatch(getChildSuppliers({
      limit: limit,
      offset: 0,
      searchList: tmpSearchList,
      noMaster: showNoMaster,
      hasMaster: showHasMaster,
      sortColumn,
      sortType
    })).then(async (res) => {
      setPaginatedData(res?.childSuppliers)
      setChildSuppliers(res?.childSuppliers)
      setCheckedSuppliers([])
      setCheckedKeys([])
    })
  }

  let filteredTableData = []
  if (!showOnlyUploadedSuppliers) {
    filteredTableData = [...childSuppliers]
  } else {
    filteredTableData = [...finalUploadedData]
    filteredTableData = filteredTableData.slice(limit * (page - 1), limit * page)
  }
  filteredTableData = [...filteredTableData].map(row => {
    if (row.masterSupplierName === "" || !row.masterSupplierName) {
      if (row.masterId) {
        row.masterSupplierName = row.masterId
      }
    }
    return row
  })

  if (!(showNoMaster && showHasMaster)) {
    if (showNoMaster) {
      filteredTableData = filteredTableData?.filter(row => !row.masterId)
    } else if (showHasMaster) {
      filteredTableData = filteredTableData?.filter(row => row.masterId)
    }
  }
  if (selectedChildrens && selectedChildrens.length > 0) {
    const nonSelectedChildrens = filteredTableData?.filter(row => selectedChildrens.findIndex(children => children.id === row.id) === -1)
    filteredTableData = [...selectedChildrens, ...nonSelectedChildrens]
  }
  filteredTableData = filteredTableData.map(row => ({
    ...row,
    supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
  }))

  const isLoading = isAssigningMaster || isLoadingChildSupplier || isRemovingFromMaster

  useEffect(() => {
    if (!(filteredTableData && filteredTableData.length > 0)) {
      setPaginatedData([])
      return
    }

    if (showOnlyUploadedSuppliers) {
      setTableTotalRecords(finalUploadedData?.length)
    }

    setPaginatedData(filteredTableData)
  }, [showOnlyUploadedSuppliers, selectedChildrens])//showHasMaster, showNoMaster,


  useEffect(async () => {
    let filteredData = [];
    const setPageData = async () => {
      var tmpSearchList = searchList
      if (suppliersSearchList?.child && Object.keys(suppliersSearchList?.child)?.length > 0) {
        var tmpSearchList = suppliersSearchList?.child
      }
      const data = await dispatch(getChildSuppliers({
        limit: limit,
        offset: limit * (page - 1),
        searchList: tmpSearchList,
        noMaster: showNoMaster,
        hasMaster: showHasMaster
      })).then(async (res) => {
        setChildSuppliers(res === undefined ? [] : res?.childSuppliers)
        setTableTotalRecords(res?.totalChilds || 0)
        setCheckedSuppliers([])
        setCheckedKeys([])
        return res
      })
      return data
    }

    const setFilteredChildrenData = async (masterIds) => {
      const data = await dispatch(getChildSuppliersWithMasterIds(masterIds, limit, limit * (page - 1))).then(async (res) => {
        setChildSuppliers(res === undefined ? [] : res?.childSuppliers)
        setTableTotalRecords(res?.totalChilds || 0)
        setCheckedSuppliers([])
        setCheckedKeys([])
        return res
      })
      return data
    }

    if (isChildrenFiltered) {
      const tableData = await setFilteredChildrenData(filteredChildrenMasterIds)
      filteredData = [...tableData?.childSuppliers]
    } else {
      if (!showOnlyUploadedSuppliers) {
        if (suppliersSearchList?.child && Object.keys(suppliersSearchList?.child)?.length > 0 && page === 1 && !showNoMaster && !showHasMaster) {
          setChildSuppliers(suppliersSearchResults?.childs?.data || [])
          setTableTotalRecords(suppliersSearchResults?.childs?.total || 0)
          setCheckedSuppliers([])
          setCheckedKeys([])
          filteredData = suppliersSearchResults?.childs?.data ? [...suppliersSearchResults?.childs?.data] : []
        } else {
          const tableData = await setPageData()
          filteredData = [...tableData?.childSuppliers]
        }
      } else {
        filteredData = [...finalUploadedData]
        filteredData = filteredData?.slice(limit * (page - 1), limit * page)
        setTableTotalRecords(finalUploadedData?.length)
      }
    }

    if (!(showNoMaster && showHasMaster)) {
      if (showNoMaster) {
        filteredData = filteredData?.filter(row => !row.masterId)
      } else if (showHasMaster) {
        filteredData = filteredData?.filter(row => row.masterId)
      }
    }
    if (selectedChildrens && selectedChildrens.length > 0) {
      const nonSelectedChildrens = filteredData?.filter(row => selectedChildrens.findIndex(children => children.id === row.id) === -1)
      filteredData = [...selectedChildrens, ...nonSelectedChildrens]
    }
    filteredTableData = filteredData.map(row => ({
      ...row,
      supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
    }))

    setPaginatedData(filteredTableData)
  }, [showNoMaster, showHasMaster, page, limit])

  return (
    <div className={`record-container lookup-record`}>
      <div className="record-header flex flex-wrap justify-space-between align-center">
        <div className="record-title flex-column flex-md-row">
          <span>Child Supplier Lookup</span>
          <div className='d-flex flex-wrap'>
            <Checkbox
              checked={showOnlyUploadedSuppliers}
              onChange={handleCheckUploadedSuppliers}
              disabled={(showNoMaster || showHasMaster)}
            >
              Only Last Uploaded Suppliers
            </Checkbox>
            <Checkbox
              checked={showNoMaster}
              onChange={handleCheckNoMaster}
              disabled={showOnlyUploadedSuppliers}
            >
              No Master
            </Checkbox>
            <Checkbox
              checked={showHasMaster}
              onChange={handleCheckHasMaster}
              disabled={showOnlyUploadedSuppliers}
            >
              Has Master
            </Checkbox>
          </div>
        </div>
        <div className="record-toolbar gap-3 flex flex-wrap align-center justify-content-end">
          <div className="toolbar-item select">
            <Select
              className="lookup-options h4 mb-0"
              classNamePrefix="lookup-options"
              options={lookupOptions}
              value={lookupOption}
              onChange={handleLookupOptionChange}
            />
          </div>
          <div className="toolbar-item gap-2">
            <button className="btn-submit ms-0 fw-normal" onClick={onSubmit}>SUBMIT</button>
            <button className="btn-submit ms-0 bg-gray ps-4 pe-4 fw-normal" onClick={onAddChildSupplier}>ADD CHILD SUPPLIER</button>
            <button className="btn-download ms-0" onClick={() => onDownload(filteredTableData)}><SvgDownload /></button>
          </div>
        </div>
      </div>
      <div className={`record-body position-relative${isLoading ? ' loading' : ''}`}>
        {isLoading && <LoaderComponent />}
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          data={paginatedData}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortTableData}
        >
          <Column width={50} align="center">
            <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Checkbox
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
                disabled={isLoading}
              />
            </HeaderCell>
            <CheckCell
              dataKey="id"
              checkedKeys={checkedKeys}
              onChange={handleCheck}
              disabled={isLoading}
            />
          </Column>
          {headerElement}
        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={totalTableRecords}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { handleChangePage(event) }}
            onChangeLength={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  )
}
export default LookupRecordComponent